<template>
	<div class="how-it-works">
		<div class="col-6 icon">
			<img>		
		</div>
		<div class="col-6 intro">
			<div class="text">
				The software scans the file offline and does not share the results publicly, unlike other anti-virus scanners currently on the market. Thus, the user can test the files with full confidence, without leaking any data to the Internet.

				To achieve this, we install operating systems with certain parameters on the server, run several antivirus scans at the same time and show the results to the end user.
			</div>
		</div>
	</div>    
</template>

<script>
export default {    
    name: 'HowItWorks'
}
</script>